/**
 * Created by bartdecorte on 15/02/2017.
 */

function AjaxWishList() {

	this.cId = undefined;
	this.wishlist = [];
	this.products = [];
	this.$container = $('#WishlistContainer');
	this.allProducts = [];

	this.settings = {
		formSelector       : 'form[action^="/cart/add"]',
		addToCartSelector  : 'input[type="submit"]',
		cartCountSelector  : null,
		cartCostSelector   : null,
		moneyFormat        : '€\{\{amount\}\}',
		disableAjaxCart    : false,
		enableQtySelectors : true
	};

	this.construct = function(params) {
		var scope = this;
		scope.cId = params.cId;

		scope.bindListeners();

		scope.fetchAllProducts(function() {
			scope.refresh();
		});
	};

	this.bindListeners = function() {
		var scope = this;
		scope.$container.on('click', '.js-line-remove', function(ev) { return scope.listeners.productRemove(scope, ev); });
		scope.$container.on('click', '.wishlist-show', function(ev) { return scope.listeners.showWishList(scope, ev); });
	};

	this.listeners = this.listeners || {};
	this.listeners.productRemove = function(scope, ev) {
		ev.preventDefault();

		var $elt = $(ev.target).get(0).tagName == 'FORM' ? $(ev.target) : $(ev.target).parents('form').first();
		var productId = $elt.find('[name="product_id"]').val();
		var variantId = $elt.find('[name="id"]').val();

		iwish_remove(productId, variantId);

		return false;
	};
	this.listeners.showWishList = function(scope, ev) {
		ev.preventDefault();

		scope.showWishList();

		return false;
	};

	this.refresh = function() {
		var scope = this;
		scope.fetchProductIds();
	};

	this.fetchAllProducts = function(success) {
		var scope = this;
		$.ajax({
			url: '/products.json',
			data: {
				limit: 250
			},
			type: 'get',
			dataType: 'json',
			success: function(response) {
				scope.allProducts = response.products;
				success();
			}
		})
	};

	this.fetchProductIds = function() {
		var scope = this;

		scope.wishlist = [];

		if (scope.cId) {
			$.ajax({
				url: '/apps/iwish',
				type: 'post',
				data: {
					cId: scope.cId
				},
				dataType: 'html',
				success: function (response) {
					var $items = jQuery(response).find('.iwish-product-form');

					var path, handle, variant, productId;
					for (var i = 0; i < $items.length; i++) {
						path = $($items[i]).find('.iwishImgWrap a').first().attr('href');
						productId = $($items[i]).data('product-id');
						handle = path.replace(/\/products\/([^\?]+)\?.*/, '$1');
						variant = path.replace(/\/products\/[^\?]+\?variant=([0-9]+).*/, '$1');
						scope.wishlist.push({
							//handle: handle,
							productId: productId,
							variantId: variant
						});
					}

					scope.gatherProducts();
					scope.renderWishList();
				}
			});
		} else {
			var iWishlistmain = JSON.parse(sessionStorage.getItem('iWishlistmain'));
			var i;
			for (var key in iWishlistmain) {
				if (iWishlistmain.hasOwnProperty(key)) {
					for (i = 0; i < iWishlistmain[key].length; i++) {
						if (iWishlistmain[key][i]) {
							scope.wishlist.push({
								productId: key,
								variantId: iWishlistmain[key][i]
							});
						}
					}
				}
			}
			scope.gatherProducts();
			scope.renderWishList();
		}
	};

	this.showWishList = function() {
		var scope = this;

		if (scope.cId) {
			iWishPost('/apps/iwish', {cId: scope.cId});
		} else {
			window.location = '/apps/iwish';
		}
	};

	this.gatherProducts = function() {
		var scope = this;

		scope.products = [];

		var i, j, entry, index, variantIndex, product;
		for (i = 0; i < scope.wishlist.length; i++) {
			entry = scope.wishlist[i];
			index = null;
			j = 0;
			while (index === null && j < scope.allProducts.length) {
				if (scope.allProducts[j].id + "" == entry.productId) index = j;
				j++;
			}

			if (index !== null && scope.allProducts[index].hasOwnProperty('variants')) {
				j = 0;
				variantIndex = null;
				while (variantIndex === null && j < scope.allProducts[index].variants.length) {
					if (scope.allProducts[index].variants[j].id == entry.variantId) variantIndex = j;
					j++;
				}
				if (variantIndex !== null) {
					product = $.extend({}, scope.allProducts[index]);
					product.variant = scope.allProducts[index].variants[variantIndex];
					scope.products.push(product);
				}
			}
		}
	};

	this.renderWishList = function() {
		var scope = this;
		// Start with a fresh cart div
		scope.$container.empty();

		// Show empty cart
		if (scope.products.length === 0) {
			var html =  '<div class="drawer__header">'+
				'<div class="drawer__title h3">Wish List</div>'+
			'<div class="drawer__close js-drawer-close">'+
			'<button type="button" class="icon-fallback-text">'+
			'<span class="icon icon-times" aria-hidden="true"></span>'+
			'<span class="fallback-text">' + "Close Cart" + '</span>'+
			'</button>'+
			'</div>'+
			'</div>' +
			'<p class="drawer__empty">Your wish list is currently empty.</p>'
			;
			scope.$container.append(html);
			//cartCallback(cart);
			return;
		}

		// Handlebars.js cart layout
		var items = [],
			item = {},
			data = {},
			source = $("#WishlistTemplate").html(),
			template = Handlebars.compile(source);

		// Add each item to our handlebars.js data
		$.each(scope.products, function(index, product) {

			/* Hack to get product image thumbnail
			 *   - If image is not null
			 *     - Remove file extension, add _small, and re-add extension
			 *     - Create server relative link
			 *   - A hard-coded url of no-image
			 */
			if (product.images.length != null){
				//var prodImg = product.images[0].replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
				var prodImg = product.images[0].src;
			} else {
				var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
			}

			// Create item's data object and add to 'items' array
			item = {
				id: product.id,
				key: '',
				line: index + 1, // Shopify uses a 1+ index in the API
				url: '/products/' + product.handle + '?variant=' + product.variant.id,
				img: prodImg,
				name: product.title,
				variation: product.variant.title,
				properties: [],
				itemAdd: 1,
				itemMinus: 1,
				itemQty: 1,
				price: Shopify.formatMoney(parseFloat(product.variant.price) * 100, scope.settings.moneyFormat),
				vendor: product.vendor,
				linePrice: Shopify.formatMoney(parseFloat(product.variant.price) * 100, scope.settings.moneyFormat),
				originalLinePrice: Shopify.formatMoney(parseFloat(product.variant.price) * 100, scope.settings.moneyFormat),
				discounts: [],
				discountsApplied: false,
				variantId: product.variant.id,
				variantAvailability: product.variant.available
			};

			items.push(item);
		});

		// Gather all cart data and add to DOM
		data = {
			items: items,
			note: '',
			totalPrice: '',
			totalCartDiscount: 0,
			totalCartDiscountApplied:false
		};

		scope.$container.append(template(data));

		//cartCallback(cart);
	};

	this.construct(arguments[0]);
}